import { Button, Typography } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";
import { useIntl } from "react-intl";

import useStyles from "./styles";

const EmptyProduct: React.FC = () => {
  const classes = useStyles();
  const intl = useIntl();
  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          {intl.formatMessage({
            defaultMessage: "รายละเอียดสินค้า"
          })}
        </Typography>
      </div>
      <div className={classes.subHeader}>
        <MyTypography variant="subtitle2" className={classes.subTitle}>
          <span className={classes.normalText}>มีทั้งหมด</span> 0{" "}
          <span className={classes.normalText}>รายการ</span>
        </MyTypography>
        <Button variant={"outlined"} disabled className={classes.btnDelete}>
          <MyTypography variant="body3" color="inherit">
            ลบทุกรายการสินค้า
          </MyTypography>
        </Button>
      </div>
    </div>
  );
};

export default EmptyProduct;
